// Generated by CoffeeScript 2.7.0
var DefaultAllLabel, DefaultNameSuffix, HierarchicalSelect, NodeSelectedStatusIcons, hierarchical_select_node_comp, hierarchical_select_tree_comp;

NodeSelectedStatusIcons = {
  selected: 'slp-check-square',
  partialSelected: 'slp-stop-square-o',
  unselected: 'slp-square-o'
};

DefaultNameSuffix = '及以下组织';

DefaultAllLabel = '所有组织';

hierarchical_select_node_comp = Vue.extend({
  name: 'hierarchical-select-node',
  template: `<div class='hierarchical-select-node' :class='nodeClassObj'>
  <div class='node-wrapper justify-between'
       :class="{ selected: node._selected }"
       @click.stop='selectNode'>
    <div class='content node-name text-ellipsis'
         :style="{ paddingLeft: (level - 1) * 1 + 'rem' }"
         @click.stop='expandNode'>
      <i :class='togglerClassObj'></i>
      <span>{{ name }}</span>
    </div>
    <div class='node-checkbox'>
      <i :class='checkboxClassName'></i>
    </div>
  </div>
  <div class='node-children'>
    <hierarchical-select-node
      v-for='child in node.children'
      :key='child.id'
      :node='child'
      :readonly='readonly'
      ref='children'
      @valueChanged='valueChanged' />
  </div>
</div>`,
  props: ['node', 'readonly', 'eagerLoadChildren'],
  data: function() {
    return {
      expanded: false
    };
  },
  created: function() {
    return this.$watch('node._selected', (newVal, oldVal) => {
      switch (this.node._selectedFlag) {
        case 'recursive-manually':
          return this.node._selectedFlag = 'recursive';
        case 'null-manually':
          return this.node._selectedFlag = null;
        default:
          this._updateSelectedFlag();
          return this.$emit('valueChanged', true);
      }
    }, {
      sync: true
    });
  },
  computed: {
    name: function() {
      if (!this.expanded && !this.node.isLeaf) {
        return `${this.node.name}${this.node.hierarchy.nameSuffix}`;
      } else {
        return this.node.name;
      }
    },
    level: function() {
      return this.node.path_ids.length;
    },
    // class objects
    nodeClassObj: function() {
      return {
        expanded: this.expanded
      };
    },
    togglerClassObj: function() {
      if (this.node.isLeaf) {
        return {
          'slp-empty': true
        };
      } else {
        return {
          'slp-chevron-right': !this.expanded,
          'slp-chevron-down': this.expanded
        };
      }
    },
    selectedStatus: function() {
      if (this.expanded) {
        if (this.node._selected) {
          return 'selected';
        } else {
          return 'unselected';
        }
      } else {
        if (this.node.isLeaf) {
          if (this.node._selected) {
            return 'selected';
          } else {
            return 'unselected';
          }
        } else {
          if (this.node._selected) {
            if (this.node.children.length === this.node.children_count) {
              if (_.every(this.node.children, function(child) {
                return child._selectedFlag === 'recursive';
              })) {
                return 'selected';
              } else {
                return 'partialSelected';
              }
            } else {
              if (this.node._selectedFlag === 'recursive') {
                return 'selected';
              } else {
                return 'partialSelected';
              }
            }
          } else {
            if (_.any(this.node.getDescendants(), function(descendant) {
              return descendant._selectedFlag !== null;
            })) {
              return 'partialSelected';
            } else {
              return 'unselected';
            }
          }
        }
      }
    },
    checkboxClassName: function() {
      return NodeSelectedStatusIcons[this.selectedStatus];
    }
  },
  methods: {
    selectNode: function() {
      if (this.readonly) {
        return;
      }
      if (this.expanded) {
        this.node._selected = !this.node._selected;
      } else {
        switch (this.selectedStatus) {
          case 'selected':
          case 'partialSelected':
            this.node._selected = false;
            break;
          default:
            this.node._selected = true;
        }
        if (this.eagerLoadChildren && this.node._selected) {
          this._fetchChildren();
        }
        this._updateSelectedOfDescendants();
      }
      return this.$emit('valueChanged', true);
    },
    expandNode: function() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        return this._fetchChildren();
      }
    },
    valueChanged: function(needUpdate = false) {
      var oldVal;
      if (needUpdate) {
        oldVal = this.node._selectedFlag;
        this._updateSelectedFlag();
        if (oldVal !== this.node._selectedFlag) {
          needUpdate = true;
        }
      }
      return this.$emit('valueChanged', needUpdate);
    },
    _updateSelectedOfDescendants: function() {
      if (this.node._selected) {
        return _.each(this.node.getDescendants(), (descent) => {
          descent._selected = true;
          return descent._selectedFlag = 'recursive';
        });
      } else {
        return _.each(this.node.getDescendants(), (descent) => {
          descent._selected = false;
          return descent._selectedFlag = null;
        });
      }
    },
    _updateSelectedFlag: function() {
      return this.node._selectedFlag = this.node._selected ? _.every(this.node.children, function(child) {
        return child._selectedFlag === 'recursive';
      }) ? 'recursive' : 'normal' : null;
    },
    _fetchChildren: function() {
      if (this.node.children_count === 0) {
        return;
      }
      if (this.node.children_count === this.node.children.length) {
        return;
      }
      return Skylark.Libs.Ajax.get(`${this.node.hierarchy.resources}/${this.node.id}/children`, {
        responseType: 'json',
        success: (rawNodes) => {
          // reset(correct) children_count if children are blank
          if (_.isBlank(rawNodes)) {
            this.node.children_count = 0;
            return this.$emit('valueChanged', true);
          } else {
            this.node.hierarchy.addNodes(rawNodes);
            return this.node.children_count = this.node.children.length;
          }
        }
      });
    }
  }
});

hierarchical_select_tree_comp = Vue.extend({
  components: {
    'hierarchical-select-node': hierarchical_select_node_comp
  },
  template: `<div class='hierarchical-select-tree'>
  <hierarchical-select-node
    :node='tree.root'
    :readonly='readonly'
    :eagerLoadChildren='eagerLoadChildren'
    ref='root'
    @valueChanged='valueChanged' />
</div>`,
  props: ['tree', 'readonly', 'eagerLoadChildren'],
  methods: {
    valueChanged: function() {
      return this.$emit('valueChanged');
    }
  }
});

export default HierarchicalSelect = Vue.extend({
  components: {
    'hierarchical-select-tree': hierarchical_select_tree_comp
  },
  template: `<div class='hierarchical-select'>
  <div :class='selectedAllClassObj' v-if='!readonly' class='hierarchical-select-all-btn justify-between' @click.stop='toggleAll'>
    <div>{{ this.allLabel }}</div>
    <div class='select-all-flag'>
      <i :class='allSelectedIconClassObj'></i>
      <span>全选</span>
    </div>
  </div>
  <div class='hierarchical-select-tree-container'>
    <hierarchical-select-tree
      v-for='tree in hierarchy.trees'
      :key="tree.root.id"
      :tree='tree'
      :readonly='readonly'
      :eagerLoadChildren='eagerLoadChildren'
      ref='trees'
      @valueChanged='valueChanged'/>
  </div>
</div>`,
  props: {
    // 初始化值，支持 ID+
    initSelectedNodeIds: {
      type: Array,
      required: false
    },
    // [必填] 节点请求地址，级联选择格式
    resources: {
      type: String,
      required: true
    },
    // recursive 时的节点名字后缀，如：及以下组织（默认值）
    nameSuffix: {
      type: String,
      requried: false,
      default: DefaultNameSuffix
    },
    // 选择所有节点的名称，如：所有组织（默认值）
    allLabel: {
      type: String,
      requried: false,
      default: DefaultAllLabel
    },
    readonly: {
      type: Boolean,
      default: false
    },
    eagerLoadChildren: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      hierarchy: new Skylark.Libs.Hierarchy(),
      selectedAll: false,
      selectedNodes: [],
      initialized: false
    };
  },
  created: function() {
    this.hierarchy.resources = this.resources;
    this.hierarchy.nameSuffix = this.nameSuffix;
    return this._initHierarchyWithSelectedNodes(this.initSelectedNodeIds);
  },
  computed: {
    selectedAllClassObj: function() {
      return {
        active: this.selectedAll
      };
    },
    allSelectedIconClassObj: function() {
      return {
        'slp-check': this.selectedAll,
        'slp-empty': !this.selectedAll
      };
    },
    selectedNodeIds: function() {
      return _.pluck(this.selectedNodes, 'composedId');
    }
  },
  methods: {
    setValue: function(ids) {
      return this._initHierarchyWithSelectedNodes(ids);
    },
    toggleAll: function() {
      if (this.readonly) {
        return;
      }
      if (this.selectedAll) {
        return this.unselectAll();
      } else {
        return this.selectAll();
      }
    },
    selectAll: function() {
      this.hierarchy.allNodesIteratee().each(function(node) {
        node._selectedFlag = node._selected ? 'recursive' : 'recursive-manually';
        return node._selected = true;
      });
      return this.valueChanged();
    },
    unselectAll: function() {
      this.hierarchy.allNodesIteratee().each(function(node) {
        node._selectedFlag = node._selected ? 'null-manually' : null;
        return node._selected = false;
      });
      return this.valueChanged();
    },
    selectNode: function(node) {
      node._selectedFlag = 'normal';
      node._selected = true;
      return this.valueChanged();
    },
    unselectNode: function(node, recursive = false) {
      node._selectedFlag = null;
      node._selected = false;
      if (recursive) {
        _.each(node.getDescendants(), function(descent) {
          descent._selected = false;
          return descent._selectedFlag = null;
        });
      }
      return this.valueChanged();
    },
    valueChanged: function() {
      this.selectedNodes = this.getSelectedNodes();
      this.selectedAll = _.every(this.hierarchy.getRootNodes(), function(root) {
        return root._selectedFlag === 'recursive';
      });
      return this.$emit('valueChanged', this);
    },
    getSelectedNodes: function() {
      return _.chain(this.hierarchy.getRootNodes()).map((root) => {
        return this._getSelectedChildrenOfNode(root);
      }).flatten().compact().each((node) => {
        if (node._selectedFlag === 'recursive' && !node.isLeaf) {
          node.composedName = `${node.name}${this.hierarchy.nameSuffix}`;
          return node.composedId = `${node.id}+`;
        } else {
          node.composedName = node.name;
          return node.composedId = node.id;
        }
      }).value();
    },
    getSelectedNodeNames: function() {
      return _.pluck(this.selectedNodes, 'composedName');
    },
    getSelectedNodeIds: function() {
      return _.pluck(this.selectedNodes, 'composedId');
    },
    _initHierarchyWithSelectedNodes: function(ids = this.initSelectedNodeIds) {
      var _ids, extractRelationship, reqUrl;
      _ids = _.map(ids, function(id) {
        return parseInt(id);
      });
      reqUrl = Skylark.Helpers.UrlHelper.generateUrlWithParams(this.resources, {
        enhanced: true,
        ids: _ids,
        include_roots: true,
        attach_ancestors: true,
        attach_siblings: !_.isEmpty(_ids)
      });
      this._setNodeParser(ids);
      extractRelationship = function(data, name) {
        return _.chain(data).map(function(node) {
          var ref;
          return (ref = node.relationships) != null ? ref[name] : void 0;
        }).flatten().compact().value();
      };
      return Skylark.Libs.Ajax.get(reqUrl, {
        responseType: 'json',
        success: (rsp) => {
          this.hierarchy.addNodes(rsp.included.roots);
          this.hierarchy.addNodes(extractRelationship(rsp.data, 'ancestors'));
          this.hierarchy.addNodes(extractRelationship(rsp.data, 'siblings'));
          this.hierarchy.addNodes(_.map(rsp.data, function(node) {
            return _.omit(node, 'relationships');
          }));
          this.hierarchy.nodeParser = (node) => {
            [node._selected, node._selectedFlag] = _.includes(this.selectedNodeIds, node.id) ? node.children_count === 0 ? [true, 'recursive'] : [true, 'normal'] : _.any(new Skylark.Libs.HierarchicalTreeNode(node).path_ids, (obj) => {
              return _.includes(this.selectedNodeIds, `${obj}+`);
            }) ? [true, 'recursive'] : [false, null];
            return node;
          };
          this.valueChanged();
          this.initialized = true;
          return this.$emit('initCompleted', this);
        }
      });
    },
    _setNodeParser: function(ids) {
      return this.hierarchy.nodeParser = (node) => {
        [node._selected, node._selectedFlag] = _.includes(ids, node.id) ? node.children_count === 0 ? [true, 'recursive'] : [true, 'normal'] : _.includes(ids, `${node.id}+`) ? [true, 'recursive'] : [false, null];
        return node;
      };
    },
    _getSelectedChildrenOfNode: function(node) {
      var nodes;
      nodes = [];
      switch (node._selectedFlag) {
        case 'recursive':
          nodes.push(node);
          break;
        case 'normal':
          nodes.push(node);
          nodes.push(_.map(node.children, (child) => {
            return this._getSelectedChildrenOfNode(child);
          }));
          break;
        default:
          nodes.push(_.map(node.children, (child) => {
            return this._getSelectedChildrenOfNode(child);
          }));
      }
      return nodes;
    }
  }
});
